import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

//DSS Documentation on ApiResult - http://tiny.sc/cgapiresult
import { ApiResult } from '@soco/core';
//DSS Documentation on SocoAlertService - http://tiny.sc/cgsocoalertservice
import { SocoAlertService } from '@soco/alert';
//DSS Documentation on SocoFormService - http://tiny.sc/cgsocoformservice
import { SocoFormService } from '@soco/forms';
//DSS Documentation on SocoHttpService - http://tiny.sc/cgSocoHttpService
import { SocoHttpService } from '@soco/http';
//DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
import { SocoModalService } from '@soco/modal';

import { UserService } from '../user.service';
import { User } from '../user';

@Component({
    selector: 'user-edit',
    templateUrl: 'user-edit.component.html'
})
export class UserEditComponent implements OnInit {
    alertId: string = 'alert-user-edit';
    modalId: string = 'modal-user-edit';
    form: FormGroup;
    @Output() userEditClosed = new EventEmitter();

    constructor(
        private userService: UserService,
        //DSS Documentation on SocoAlertService - http://tiny.sc/cgsocoalertservice
        private socoAlertService: SocoAlertService,
        //DSS Documentation on SocoFormService - http://tiny.sc/cgsocoformservice
        private socoFormService: SocoFormService,
        //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
        private socoModalService: SocoModalService,
        private http: SocoHttpService,
        private formBuilder: FormBuilder
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group(new User());
    }

    //=============================================================================================================
    //EVENT HANDLERS
    //=============================================================================================================
    formSubmitted(user: User): void {
        this.update(user);
    }

    deleteClicked(user: User): void {
        this.del(user.id);
    }

    show(id: number): void {
        this.getById(id);
    }

    //=============================================================================================================
    //WEB METHODS
    //=============================================================================================================
    private getById(id: number): void {
        this.userService.getById(id).subscribe(result => {
            //set the data on the form
            this.form = this.formBuilder.group(result.data);

            //show the modal
            //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
            this.socoModalService.show({
                id: this.modalId,
                onClose: () => {
                    this.userEditClosed.emit();
                }
            });
        }, result => {
            // do nothing
        });
    }

    private update(user: User): void {
        this.userService.update(user, this.alertId).subscribe(result => {
            //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
            this.socoModalService.hide(); //hide the modal which will trigger the event emitter so the parent will refresh
        }, result => {
            //DSS Documentation on SocoFormService - http://tiny.sc/cgsocoformservice
            //DSS Documentation on Validation - http://tiny.sc/cgvalidation
            if (this.http.isInvalidResult(result)) {
                this.form = this.socoFormService.invalidateForm(this.form, result);
            }
        });
    }

    private del(id: number): void {
        //hide any alerts from the last time the form was submitted
        //DSS Documentation on SocoAlertService - http://tiny.sc/cgsocoalertservice
        this.socoAlertService.hide();

        //delete
        this.userService.del(id, this.alertId).subscribe(result => {
            //DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
            this.socoModalService.hide(); //hide the modal which will trigger the event emitter so the parent will refresh
        });
    }
}

